export const API_EXTERNAL_ENDPOINT = 'cottages/detail/:province/:slug/phones'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/detail/phones'
